__turbopack_context__.v({
  "flushBottom": "BlockPaperForm-module-scss-module__q9QeKG__flushBottom",
  "flushTop": "BlockPaperForm-module-scss-module__q9QeKG__flushTop",
  "iframeWrapper": "BlockPaperForm-module-scss-module__q9QeKG__iframeWrapper",
  "richText": "BlockPaperForm-module-scss-module__q9QeKG__richText",
  "richTextHeading": "BlockPaperForm-module-scss-module__q9QeKG__richTextHeading",
  "richTextSpacer": "BlockPaperForm-module-scss-module__q9QeKG__richTextSpacer",
  "richTextUnorderedList": "BlockPaperForm-module-scss-module__q9QeKG__richTextUnorderedList",
  "root": "BlockPaperForm-module-scss-module__q9QeKG__root",
});
